import { getWindow } from 'ssr-window';
import { environment } from '../../environments/environment';

export const isSandbox = () => environment.sandbox || (getWindow().location.hostname.split('.').includes('sandbox') ?? false);

